import React, { useContext, useEffect, useState } from 'react'
import { CheckValidation } from '../../Components/Validations';
import { LogInSchoolID } from '../../JS/Common';
import { ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { UserContext } from '../../App';
import useConfig from '../../Hooks/useConfig';
import SettingBoxWrapper from './SettingBoxWrapper';

export default function PaymentLink({ setLoading, setNewAlerts }) {
    const { manager } = useConfig();

    const { UserData, setUserData } = useContext(UserContext);
    const [PaymentLinkVal, setPaymentLinkVal] = useState('');
    const [PaymentLinkFlag, setPaymentLinkFlag] = useState(UserData.PaymentLinkFlag);

    useEffect(() => {
        setPaymentLinkVal(UserData.PaymentLink)
        setPaymentLinkFlag(UserData.PaymentLinkFlag)
    }, [UserData.PaymentLink, UserData.PaymentLinkFlag]);

    async function SavePaymentLink() {
        if (PaymentLinkFlag == 1) {
            var isFormValid = CheckValidation({ formID: 'PaymentLinkDiv' });
            if (!isFormValid) return;
        }
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            paymentLink: PaymentLinkFlag == 1 ? PaymentLinkVal : null,
            flag: PaymentLinkFlag
        });
        setLoading(true)
        await ApiPostCall("/settings/external-payment-link/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Payment Link Added Successfully."} />);
                    setTimeout(() => {
                        setUserData((prevUserData) => ({ ...prevUserData, PaymentLink: PaymentLinkVal, PaymentLinkFlag: PaymentLinkFlag }));
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const handlePaymentLinkVal = () => {
        let value = PaymentLinkVal;

        if (value && !value.startsWith("http://") && !value.startsWith("https://")) {
            value = "https://" + value;
            setPaymentLinkVal(value);
        }
    }
    return (
        <>
            <SettingBoxWrapper
                BoxTitle={'External Payment Link'}
                BoxLabel={`Do you want to add a payment link to Ticket Invoices?`}
            >
                <div className='col-md-12 mt-3 d-flex align-items-center'>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='Paymentlink'
                            onChange={(e) => { setPaymentLinkFlag(1); setPaymentLinkVal('') }}
                            defaultChecked={PaymentLinkFlag == 1}
                        />
                        <label className="form-check-label">On</label>
                    </div>
                    <div className="form-check ms-5">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='Paymentlink'
                            onChange={(e) => setPaymentLinkFlag(0)}
                            defaultChecked={PaymentLinkFlag != 1}
                        />
                        <label className="form-check-label">Off</label>
                    </div>
                </div>
                {PaymentLinkFlag == 1 && (
                    <div className='col-12 pb-2 pt-3 parent' id="PaymentLinkDiv">
                        <label className='pb-1'>Enter External Payment Link</label>
                        <div className="input-group ">
                            <input type="text" autoComplete='off' className="form-control px-3" name='paymentlink' required
                                value={PaymentLinkVal} onChange={(e) => {
                                    setPaymentLinkVal(e.target.value);
                                }} onBlur={handlePaymentLinkVal} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>


                    </div>
                )}
                <div className='pt-2'>
                    <button className="SaveBtn" onClick={SavePaymentLink}> Confirm   </button>
                </div>
            </SettingBoxWrapper>
        </>

    )
}
